import { toast } from 'react-toastify';

export const showToast = (type = 'info', message, timeout=3000) => {
  switch (type) {
    case 'success':
      toast.success(message, {
        //position: toast.POSITION.BOTTOM_CENTER,
        autoClose: timeout,
      });
      break;
    case 'error':
      toast.error(message, {
        //position: toast.POSITION.BOTTOM_CENTER,
        autoClose: timeout,
      });
      break;
    case 'warning':
      toast.warning(message, {
        //position: toast.POSITION.BOTTOM_CENTER,
        autoClose: timeout,
      });
      break;
    default:
      toast.info(message, {
        //position: toast.POSITION.BOTTOM_CENTER,
        autoClose: timeout,
      });
      break;
  }
};
